(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindContactForms = (root = document) => {
      root.querySelectorAll('#HomepageContactForm').forEach((form) => {
        if (form.dataset.feedbackBound) return;
        form.dataset.feedbackBound = 'true';
        const submitButton = form.querySelector('[data-contact-submit]');
        const submitStatus = form.querySelector('[data-contact-submit-status]');
        if (!submitButton) return;

        form.addEventListener('submit', () => {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.textContent = 'Sending…';
          if (submitStatus) submitStatus.textContent = 'Sending your message…';
        });
      });
    };

    bindContactForms();
    document.addEventListener('shopify:section:load', (event) => bindContactForms(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!window.timeureFooterLocalizationDismissBound) {
    window.timeureFooterLocalizationDismissBound = true

    document.addEventListener('pointerdown', (event) => {
      document.querySelectorAll('.footer-localization__dropdown[open]').forEach((dropdown) => {
        if (!dropdown.contains(event.target)) dropdown.removeAttribute('open')
      })
    })

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return

      document.querySelectorAll('.footer-localization__dropdown[open]').forEach((dropdown) => {
        dropdown.removeAttribute('open')
        dropdown.querySelector('summary')?.focus()
      })
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-country-selector]').forEach(selector=>{if(selector.dataset.countrySelectorBound)return;selector.dataset.countrySelectorBound='true';selector.addEventListener('change',()=>selector.form?.requestSubmit())});

  if (!window.timeureHeaderLocalizationDismissBound) {
    window.timeureHeaderLocalizationDismissBound = true

    const closeHeaderLocalization = (dropdown, restoreFocus = false) => {
      if (!dropdown.open || dropdown.classList.contains('is-closing')) return
      dropdown.classList.add('is-closing')
      window.setTimeout(() => {
        dropdown.removeAttribute('open')
        dropdown.classList.remove('is-closing')
        delete dropdown.dataset.wasOpen
        if (restoreFocus) dropdown.querySelector('summary')?.focus({ preventScroll: true })
      }, 220)
    }

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.header-localization__dropdown summary')
      if (!summary) return
      const dropdown = summary.closest('.header-localization__dropdown')
      const wasOpen = dropdown.dataset.wasOpen == null ? dropdown.open : dropdown.dataset.wasOpen === 'true'
      event.preventDefault()
      delete dropdown.dataset.wasOpen

      if (wasOpen) {
        dropdown.setAttribute('open', '')
        closeHeaderLocalization(dropdown)
      } else {
        dropdown.classList.remove('is-closing')
        dropdown.setAttribute('open', '')
      }
    }, true)

    document.addEventListener('pointerdown', (event) => {
      const summary = event.target.closest('.header-localization__dropdown summary')
      if (summary) summary.closest('.header-localization__dropdown').dataset.wasOpen = summary.parentElement.open

      document.querySelectorAll('.header-localization__dropdown[open]').forEach((dropdown) => {
        if (!dropdown.contains(event.target)) closeHeaderLocalization(dropdown)
      })
    })

    document.addEventListener('keydown', (event) => {
      const summary = event.target.closest('.header-localization__dropdown summary')
      if (summary && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault()
        const dropdown = summary.closest('.header-localization__dropdown')
        if (dropdown.open) closeHeaderLocalization(dropdown)
        else dropdown.setAttribute('open', '')
        return
      }

      if (event.key !== 'Escape') return
      document.querySelectorAll('.header-localization__dropdown[open]').forEach((dropdown) => {
        event.preventDefault()
        closeHeaderLocalization(dropdown, true)
      })
    })
  }

  if (!window.timeureHeaderAccountBound) {
    window.timeureHeaderAccountBound = true
    const accountToggle = document.querySelector('[data-header-account-toggle]')
    const accountPanel = document.querySelector('[data-header-account-panel]')

    if (accountToggle && accountPanel) {
      const closeHeaderAccount = (restoreFocus = false) => {
        if (!accountPanel.hasAttribute('data-open') || accountPanel.classList.contains('is-closing')) return
        accountPanel.classList.add('is-closing')
        window.setTimeout(() => {
          accountPanel.removeAttribute('data-open')
          accountPanel.classList.remove('is-closing')
          accountPanel.setAttribute('aria-hidden', 'true')
          accountToggle.setAttribute('aria-expanded', 'false')
          if (restoreFocus) accountToggle.focus({ preventScroll: true })
        }, 220)
      }

      const openHeaderAccount = () => {
        const searchPanel = document.querySelector('[data-header-search-panel]')
        const searchToggle = document.querySelector('[data-header-search-toggle]')
        const cartPanel = document.querySelector('[data-header-cart-panel]')
        const cartToggle = document.querySelector('[data-header-cart-toggle]')
        searchPanel?.removeAttribute('data-open')
        searchPanel?.classList.remove('is-closing')
        searchPanel?.setAttribute('aria-hidden', 'true')
        searchToggle?.setAttribute('aria-expanded', 'false')
        cartPanel?.removeAttribute('data-open')
        cartPanel?.classList.remove('is-closing')
        cartPanel?.setAttribute('aria-hidden', 'true')
        cartToggle?.setAttribute('aria-expanded', 'false')
        accountPanel.classList.remove('is-closing')
        accountPanel.setAttribute('data-open', '')
        accountPanel.setAttribute('aria-hidden', 'false')
        accountToggle.setAttribute('aria-expanded', 'true')
        document.querySelectorAll('.header-localization__dropdown[open]').forEach((dropdown) => dropdown.removeAttribute('open'))
      }

      accountToggle.addEventListener('click', () => {
        if (accountPanel.hasAttribute('data-open')) closeHeaderAccount()
        else openHeaderAccount()
      })

      document.addEventListener('pointerdown', (event) => {
        if (!accountPanel.contains(event.target) && !accountToggle.contains(event.target)) closeHeaderAccount()
      })

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !accountPanel.hasAttribute('data-open')) return
        event.preventDefault()
        closeHeaderAccount(true)
      })
    }
  }

  if (!window.timeureHeaderSearchBound) {
    window.timeureHeaderSearchBound = true
    const searchToggle = document.querySelector('[data-header-search-toggle]')
    const searchPanel = document.querySelector('[data-header-search-panel]')
    const searchClose = document.querySelector('[data-header-search-close]')

    if (searchToggle && searchPanel) {
      const searchInput = searchPanel.querySelector('[data-predictive-search-input]')

      const openHeaderSearch = () => {
        const cartPanel = document.querySelector('[data-header-cart-panel]')
        const cartToggle = document.querySelector('[data-header-cart-toggle]')
        cartPanel?.removeAttribute('data-open')
        cartPanel?.classList.remove('is-closing')
        cartPanel?.setAttribute('aria-hidden', 'true')
        cartToggle?.setAttribute('aria-expanded', 'false')
        searchPanel.classList.remove('is-closing')
        searchPanel.setAttribute('data-open', '')
        searchPanel.setAttribute('aria-hidden', 'false')
        searchToggle.setAttribute('aria-expanded', 'true')
        document.querySelectorAll('.header-localization__dropdown[open]').forEach((dropdown) => dropdown.removeAttribute('open'))
        window.setTimeout(() => searchInput?.focus({ preventScroll: true }), 80)
      }

      const closeHeaderSearch = (restoreFocus = false) => {
        if (!searchPanel.hasAttribute('data-open') || searchPanel.classList.contains('is-closing')) return
        searchPanel.classList.add('is-closing')
        searchInput?.setAttribute('aria-expanded', 'false')
        window.setTimeout(() => {
          searchPanel.removeAttribute('data-open')
          searchPanel.classList.remove('is-closing')
          searchPanel.setAttribute('aria-hidden', 'true')
          searchToggle.setAttribute('aria-expanded', 'false')
          if (restoreFocus) searchToggle.focus({ preventScroll: true })
        }, 220)
      }

      searchToggle.addEventListener('click', () => {
        if (searchPanel.hasAttribute('data-open')) closeHeaderSearch()
        else openHeaderSearch()
      })

      searchClose?.addEventListener('click', () => closeHeaderSearch(true))

      document.addEventListener('pointerdown', (event) => {
        if (!searchPanel.contains(event.target) && !searchToggle.contains(event.target)) closeHeaderSearch()
      })

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !searchPanel.hasAttribute('data-open')) return
        event.preventDefault()
        closeHeaderSearch(true)
      })
    }

    document.querySelectorAll('[data-predictive-search-form]').forEach((form) => {
      if (form.dataset.predictiveSearchBound) return
      form.dataset.predictiveSearchBound = 'true'
      const input = form.querySelector('[data-predictive-search-input]')
      const results = form.querySelector('[data-predictive-search-results]')
      let debounceTimer
      let requestController

      input.addEventListener('input', () => {
        window.clearTimeout(debounceTimer)
        requestController?.abort()
        const term = input.value.trim()

        if (!term) {
          results.replaceChildren()
          input.setAttribute('aria-expanded', 'false')
          return
        }

        debounceTimer = window.setTimeout(async () => {
          requestController = new AbortController()
          results.setAttribute('aria-busy', 'true')

          try {
            const url = `${form.dataset.predictiveUrl}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide&section_id=predictive-search`
            const response = await fetch(url, { signal: requestController.signal })
            if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`)
            const text = await response.text()
            const markup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search')?.innerHTML
            if (input.value.trim() !== term) return
            results.innerHTML = markup || ''
            input.setAttribute('aria-expanded', results.hasChildNodes() ? 'true' : 'false')
          } catch (error) {
            if (error.name !== 'AbortError') {
              results.replaceChildren()
              input.setAttribute('aria-expanded', 'false')
            }
          } finally {
            results.removeAttribute('aria-busy')
          }
        }, 250)
      })
    })
  }

  if (!window.timeureHeaderCartBound) {
    window.timeureHeaderCartBound = true
    const cartToggle = document.querySelector('[data-header-cart-toggle]')
    const cartPanel = document.querySelector('[data-header-cart-panel]')
    const cartClose = document.querySelector('[data-header-cart-close]')

    if (cartToggle && cartPanel) {
      const openHeaderCart = () => {
        const searchPanel = document.querySelector('[data-header-search-panel]')
        const searchToggle = document.querySelector('[data-header-search-toggle]')
        searchPanel?.removeAttribute('data-open')
        searchPanel?.classList.remove('is-closing')
        searchPanel?.setAttribute('aria-hidden', 'true')
        searchToggle?.setAttribute('aria-expanded', 'false')
        cartPanel.classList.remove('is-closing')
        cartPanel.setAttribute('data-open', '')
        cartPanel.setAttribute('aria-hidden', 'false')
        cartToggle.setAttribute('aria-expanded', 'true')
        document.querySelectorAll('.header-localization__dropdown[open]').forEach((dropdown) => dropdown.removeAttribute('open'))
      }

      const closeHeaderCart = (restoreFocus = false) => {
        if (!cartPanel.hasAttribute('data-open') || cartPanel.classList.contains('is-closing')) return
        cartPanel.classList.add('is-closing')
        window.setTimeout(() => {
          cartPanel.removeAttribute('data-open')
          cartPanel.classList.remove('is-closing')
          cartPanel.setAttribute('aria-hidden', 'true')
          cartToggle.setAttribute('aria-expanded', 'false')
          if (restoreFocus) cartToggle.focus({ preventScroll: true })
        }, 220)
      }

      cartToggle.addEventListener('click', () => {
        if (cartPanel.hasAttribute('data-open')) closeHeaderCart()
        else openHeaderCart()
      })

      cartClose?.addEventListener('click', () => closeHeaderCart(true))

      document.addEventListener('pointerdown', (event) => {
        if (!cartPanel.contains(event.target) && !cartToggle.contains(event.target)) closeHeaderCart()
      })

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !cartPanel.hasAttribute('data-open')) return
        event.preventDefault()
        closeHeaderCart(true)
      })
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-carousel]').forEach(carousel=>{
    const slides=[...carousel.querySelectorAll('[data-hero-slide]')];
    const dots=[...carousel.querySelectorAll('[data-hero-dot]')];
    const previous=carousel.querySelector('[data-hero-prev]');
    const next=carousel.querySelector('[data-hero-next]');
    const toggle=carousel.querySelector('[data-hero-toggle]');
    const cta=carousel.querySelector('[data-hero-cta]');
    if(slides.length<2)return;
    let current=0;
    let timer;
    let paused=false;
    const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval=Math.max(3,Number(carousel.dataset.autoplaySeconds)||5)*1000;
    const stop=()=>{if(timer){window.clearInterval(timer);timer=undefined;}};
    const updateToggle=()=>{if(!toggle)return;toggle.textContent=paused?'▶':'Ⅱ';toggle.setAttribute('aria-label',paused?toggle.dataset.playLabel:toggle.dataset.pauseLabel);};
    const show=index=>{
      current=(index+slides.length)%slides.length;
      slides.forEach((slide,slideIndex)=>{const active=slideIndex===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.tabIndex=active?0:-1;});
      dots.forEach((dot,dotIndex)=>{const active=dotIndex===current;dot.classList.toggle('is-active',active);dot.setAttribute('aria-current',String(active));});
      if(cta)cta.href=slides[current].dataset.productUrl;
    };
    const start=()=>{stop();if(carousel.dataset.autoplay==='true'&&!paused&&!reduceMotion)timer=window.setInterval(()=>show(current+1),interval);};
    const useControl=index=>{paused=true;stop();show(index);updateToggle();};
    previous?.addEventListener('click',()=>useControl(current-1));
    next?.addEventListener('click',()=>useControl(current+1));
    dots.forEach((dot,index)=>dot.addEventListener('click',()=>useControl(index)));
    toggle?.addEventListener('click',()=>{paused=!paused;updateToggle();paused?stop():start();});
    carousel.addEventListener('mouseenter',stop);
    carousel.addEventListener('mouseleave',start);
    carousel.addEventListener('focusin',stop);
    carousel.addEventListener('focusout',event=>{if(!carousel.contains(event.relatedTarget))start();});
    document.addEventListener('shopify:block:select',event=>{const slide=event.target.closest?.('[data-hero-slide]');const index=slides.indexOf(slide);if(index>=0)useControl(index);});
    updateToggle();
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initGallerySlider(slider) {
      if (slider.dataset.galleryReady === 'true') return;
      slider.dataset.galleryReady = 'true';

      const slides = Array.from(slider.querySelectorAll('[data-gallery-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-gallery-dot]'));
      const previous = slider.querySelector('[data-gallery-prev]');
      const next = slider.querySelector('[data-gallery-next]');
      const toggle = slider.querySelector('[data-gallery-toggle]');
      const toggleIcon = slider.querySelector('[data-gallery-toggle-icon]');
      const status = slider.querySelector('[data-gallery-status]');
      if (slides.length < 2 || !previous || !next || !toggle) return;

      let activeIndex = 0;
      let timer;
      let pausedByUser = false;
      const pauseLabel = slider.dataset.pauseLabel;
      const playLabel = slider.dataset.playLabel;

      function showSlide(index, announce) {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if (slide.matches('a')) slide.tabIndex = isActive ? 0 : -1;
          if (dots[slideIndex]) dots[slideIndex].classList.toggle('is-active', isActive);
        });
        if (announce && status) status.textContent = `${activeIndex + 1} / ${slides.length}`;
      }

      function stop() {
        window.clearInterval(timer);
      }

      function start() {
        stop();
        if (pausedByUser || reducedMotion.matches || document.hidden) return;
        timer = window.setInterval(() => showSlide(activeIndex + 1, false), 5200);
      }

      function updateToggle() {
        toggle.setAttribute('aria-label', pausedByUser ? playLabel : pauseLabel);
        toggleIcon.textContent = pausedByUser ? '▶' : 'Ⅱ';
      }

      previous.addEventListener('click', () => {
        showSlide(activeIndex - 1, true);
        start();
      });
      next.addEventListener('click', () => {
        showSlide(activeIndex + 1, true);
        start();
      });
      toggle.addEventListener('click', () => {
        pausedByUser = !pausedByUser;
        updateToggle();
        if (pausedByUser) stop(); else start();
      });
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', (event) => {
        if (!slider.contains(event.relatedTarget)) start();
      });
      document.addEventListener('visibilitychange', start);
      reducedMotion.addEventListener('change', start);

      showSlide(0, false);
      updateToggle();
      start();
    }

    function initGalleryProductCard(card) {
      if (card.dataset.productCardReady === 'true') return;
      card.dataset.productCardReady = 'true';

      const image = card.querySelector('.gallery-card__product-image');
      const variantButtons = Array.from(card.querySelectorAll('[data-gallery-variant]'));
      const productLinks = Array.from(card.querySelectorAll('[data-gallery-product-link]'));
      if (!image || variantButtons.length === 0) return;

      variantButtons.forEach((button) => {
        button.addEventListener('click', () => {
          variantButtons.forEach((item) => {
            const isSelected = item === button;
            item.classList.toggle('is-active', isSelected);
            item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });

          productLinks.forEach((link) => {
            link.href = button.dataset.variantUrl;
          });

          if (!button.dataset.imageSrc) return;
          image.classList.add('is-changing');
          image.addEventListener('load', () => image.classList.remove('is-changing'), { once: true });
          image.srcset = button.dataset.imageSrcset;
          image.src = button.dataset.imageSrc;
          image.alt = button.dataset.imageAlt;
          if (image.complete) requestAnimationFrame(() => image.classList.remove('is-changing'));
        });
      });
    }

    function initAllGalleryCards(scope = document) {
      scope.querySelectorAll('[data-gallery-slider]').forEach(initGallerySlider);
      scope.querySelectorAll('[data-gallery-product-card]').forEach(initGalleryProductCard);
    }

    initAllGalleryCards();
    document.addEventListener('shopify:section:load', (event) => initAllGalleryCards(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]')
    const picker = root.querySelector('[data-variant-picker]')
    const toggle = root.querySelector('[data-variant-toggle]')
    const current = root.querySelector('[data-variant-current]')
    const variantOptions = [...root.querySelectorAll('[data-variant-option]')]
    if (select) {
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0]
        root.querySelector('[data-variant-id]').value = option.value
        root.querySelector('[data-product-price]').textContent = option.dataset.price
        history.replaceState({}, '', `${location.pathname}?variant=${option.value}`)
      })
    }

    if (select && picker && toggle && !picker.dataset.bound) {
      let closeTimer

      const openPicker = () => {
        window.clearTimeout(closeTimer)
        picker.classList.remove('is-closing')
        picker.setAttribute('data-open', '')
        toggle.setAttribute('aria-expanded', 'true')
      }

      const closePicker = (restoreFocus = false) => {
        if (!picker.hasAttribute('data-open')) return
        picker.classList.add('is-closing')
        toggle.setAttribute('aria-expanded', 'false')
        closeTimer = window.setTimeout(() => {
          picker.removeAttribute('data-open')
          picker.classList.remove('is-closing')
          if (restoreFocus) toggle.focus()
        }, 220)
      }

      toggle.addEventListener('click', () => {
        if (picker.hasAttribute('data-open')) closePicker()
        else openPicker()
      })

      toggle.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown') return
        event.preventDefault()
        openPicker()
        window.requestAnimationFrame(() => {
          const selectedOption = variantOptions.find((option) => option.getAttribute('aria-selected') === 'true' && !option.disabled)
          selectedOption?.focus()
        })
      })

      variantOptions.forEach((variantOption) => {
        variantOption.addEventListener('click', () => {
          if (variantOption.disabled) return
          select.value = variantOption.dataset.value
          current.textContent = variantOption.dataset.label
          variantOptions.forEach((option) => option.setAttribute('aria-selected', String(option === variantOption)))
          select.dispatchEvent(new Event('change', { bubbles: true }))
          closePicker(true)
        })
      })

      document.addEventListener('pointerdown', (event) => {
        if (!picker.contains(event.target)) closePicker()
      })

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && picker.hasAttribute('data-open')) closePicker(true)
      })

      picker.dataset.bound = 'true'
    }

    const quantity = root.querySelector('[data-quantity-input]')
    const decrease = root.querySelector('[data-quantity-decrease]')
    const increase = root.querySelector('[data-quantity-increase]')
    if (!quantity || !decrease || !increase) return

    const normalizeQuantity = () => {
      const minimum = Number(quantity.min) || 1
      const maximum = quantity.max ? Number(quantity.max) : Number.POSITIVE_INFINITY
      const current = Number(quantity.value)
      const normalized = Math.min(maximum, Math.max(minimum, Number.isFinite(current) ? current : minimum))
      quantity.value = String(normalized)
      decrease.disabled = normalized <= minimum
      increase.disabled = normalized >= maximum
    }

    const changeQuantity = (direction) => {
      const step = Number(quantity.step) || 1
      quantity.value = String((Number(quantity.value) || 1) + direction * step)
      normalizeQuantity()
      quantity.dispatchEvent(new Event('change', { bubbles: true }))
    }

    decrease.addEventListener('click', () => changeQuantity(-1))
    increase.addEventListener('click', () => changeQuantity(1))
    quantity.addEventListener('change', normalizeQuantity)
    quantity.addEventListener('blur', normalizeQuantity)
    normalizeQuantity()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const galleries = new WeakMap();
    const mediaQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initialize = (gallery) => {
      if (galleries.has(gallery)) return;
      const cards = [...gallery.querySelectorAll('.ugc-card')];
      if (cards.length < 2) return;

      let timer;
      let resumeTimer;
      let isVisible = true;

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = undefined;
        }
      };

      const advance = () => {
        if (!mediaQuery.matches || reducedMotionQuery.matches || document.hidden) return;
        const cardWidth = cards[0].getBoundingClientRect().width;
        const gap = parseFloat(window.getComputedStyle(gallery).columnGap || window.getComputedStyle(gallery).gap) || 0;
        const step = cardWidth + gap;
        const maximum = gallery.scrollWidth - gallery.clientWidth;
        if (step <= 0 || maximum <= 1) return;

        if (gallery.scrollLeft >= maximum - 4) {
          gallery.scrollTo({left: 0, behavior: 'smooth'});
        } else {
          gallery.scrollBy({left: step, behavior: 'smooth'});
        }
      };

      const start = () => {
        stop();
        if (!isVisible || !mediaQuery.matches || reducedMotionQuery.matches || document.hidden) return;
        timer = window.setInterval(advance, 4500);
      };

      const pauseForInteraction = () => {
        stop();
        window.clearTimeout(resumeTimer);
      };

      const resumeAfterInteraction = () => {
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(start, 3000);
      };

      gallery.addEventListener('mouseenter', pauseForInteraction);
      gallery.addEventListener('mouseleave', start);
      gallery.addEventListener('focusin', pauseForInteraction);
      gallery.addEventListener('focusout', (event) => {
        if (!gallery.contains(event.relatedTarget)) resumeAfterInteraction();
      });
      gallery.addEventListener('pointerdown', pauseForInteraction, {passive: true});
      gallery.addEventListener('pointerup', resumeAfterInteraction, {passive: true});
      gallery.addEventListener('pointercancel', resumeAfterInteraction, {passive: true});
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          isVisible = entries[0]?.isIntersecting ?? true;
          isVisible ? start() : stop();
        }, {threshold: 0.1});
        observer.observe(gallery);
      }

      const onMediaChange = () => start();
      if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', onMediaChange);
      else mediaQuery.addListener(onMediaChange);
      if (reducedMotionQuery.addEventListener) reducedMotionQuery.addEventListener('change', onMediaChange);
      else reducedMotionQuery.addListener(onMediaChange);

      galleries.set(gallery, {stop});
      start();
    };

    const initializeAll = (root = document) => root.querySelectorAll('[data-ugc-gallery]').forEach(initialize);
    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
